

















































































































import { defineComponent } from '@vue/composition-api';
import { accessor } from '../store';
import Vue from 'vue';
import axios from 'axios';

export default defineComponent({
  data() {
    return {
      showContent: false,
      showContent2: false,
      openDialog: false,
      cardFlag: '',
      dialogItems: {
        title: '',
        text: '',
        cancelCss: '',
        okCss: '',
        cancelBtnText: '',
        okBtnText: ''
      },
      errorMessageCode: 0,
      cancelCall: function () {
        this.openDialog = false;
      }
    };
  },
  computed: {
    placeKindValue: {
      get() {
        return accessor.newPlaceKindValue;
      },
      set(value) {
        accessor.setNewPlaceKindValue(value);
      }
    },
    postKindValue: {
      get() {
        return accessor.newPostKindValue;
      },
      set(value) {
        accessor.setNewPostKindValue(value);
      }
    },
    popupFlag: {
      get() {
        return accessor.newPopupFlag;
      },
      set(value) {
        accessor.setNewPopupFlag(value);
      }
    }
  },
  methods: {
    openModal: function () {
      this.showContent = true;
    },
    closeModal: function () {
      this.showContent = false;
    },
    toNext() {
      const data = JSON.stringify({
        kyokaNo1: accessor.newKyokaNo1,
        kyokaNo2: accessor.newKyokaNo2,
        kindValue: accessor.newKindValue
      });
      const url = Vue.prototype.$API_URL + 'common';
      axios.post(url, data, Vue.prototype.$AXIOS_REQ_HEADER)
        .then(response => {
          //許可期限に問題がある場合
          this.dialogItems.title = response.data.errorMessageTitle;
          this.dialogItems.text = response.data.errorMessageText;
          this.dialogItems.cancelCss = 'blue';
          this.dialogItems.cancelBtnText = '戻る';
          this.errorMessageCode = response.data.errorMessageCode;
          this.cancelCall = this.cancelBtn;
          if ((this.errorMessageCode === 3) || (this.errorMessageCode === 4)) {
            this.dialogItems.textCss = 'redtext';
            this.dialogItems.sizeCss = 'big';
          } else {
            this.dialogItems.textCss = 'blacktext';
            this.dialogItems.sizeCss = 'nomal';
          }
          if (this.errorMessageCode === 1 || this.errorMessageCode === 2 || this.errorMessageCode === 3 || this.errorMessageCode === 6) {
            this.openDialog = true;
          } else if ((this.postKindValue === '1' && this.errorMessageCode === 4) ||
                     (this.postKindValue === '1' && this.errorMessageCode === 5)) {
            this.openDialog = true;
          } else {
            if (this.postKindValue === '1') {
              if (this.popupFlag === '0') {
                this.showContent2 = true;
                this.popupFlag = '1';
              } else {
                this.$router.push({ path: 'choice', query: { newChangeFlagProps: 'new' } });
              }
            } else {
              this.$router.push({ path: 'choice', query: { newChangeFlagProps: 'new' } });
            }
          }
        }).catch((ex) => {
          if (ex.response) {
            console.error(ex.response.data.error);
          }
          this.message = '入力した許可番号に誤りがあります。';
        });
    },
    cancelBtn() {
      this.openDialog = false;
    },
    okBtn() {
      this.$router.push({ path: 'choice', query: { newChangeFlagProps: 'new' } });
    }
  }
});
